import { NavLink } from "react-router-dom";
import { Home, User, PlayCircle, Mic2, Wallet } from "lucide-react";

const navItems = [
  { path: "/", icon: Home, label: "Inicio" },
  { path: "/usuario", icon: User, label: "Usuario" },
  { path: "/videos", icon: PlayCircle, label: "Video" },
  { path: "/artistas", icon: Mic2, label: "Artista" },
  { path: "/pagos", icon: Wallet, label: "Pago" },
];

const BottomNav = () => {
  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 h-16 glass border-t border-white/10 z-50"
      data-testid="bottom-nav"
    >
      <div className="flex items-center justify-around h-full max-w-lg mx-auto px-2">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            data-testid={`nav-${item.label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center w-16 h-full transition-all duration-200 ${
                isActive
                  ? "text-[#D946EF]"
                  : "text-gray-400 hover:text-white"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <div className={`p-2 rounded-xl transition-all ${isActive ? "bg-[#D946EF]/20 glow-primary" : ""}`}>
                  <item.icon className={`w-5 h-5 ${isActive ? "stroke-[2.5]" : ""}`} />
                </div>
                <span className={`text-[10px] mt-0.5 font-medium ${isActive ? "text-[#D946EF]" : ""}`}>
                  {item.label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
